import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  getOperationsIntakeItems,
  getOperationsItems,
  getOperationsJourneyItems,
  getOperationsSummary,
  type OperationsIntakeItemsDto,
  type OperationsIntakeItemsFilter,
  type OperationsJourneyItemsDto,
  type OperationsJourneyItemsFilter,
  type OperationsItemsDto,
  type OperationsItemsFilter,
  type OperationsParams,
  type OperationsSummaryDto,
} from "@/api/endpoints";
import { operationsRetry, operationsRetryDelay } from "./operationsWarming";

export function useOperationsSummaryQuery(params: OperationsParams) {
  return useQuery<OperationsSummaryDto>({
    queryKey: ["operations", "summary", params],
    queryFn: () => getOperationsSummary(params),
    staleTime: 60_000,
    retry: operationsRetry,
    retryDelay: operationsRetryDelay,
    placeholderData: keepPreviousData,
  });
}

export function useOperationsItemsQuery(params: OperationsParams, filter: OperationsItemsFilter, enabled: boolean) {
  return useQuery<OperationsItemsDto>({
    queryKey: ["operations", "items", params, filter],
    queryFn: () => getOperationsItems(params, filter),
    staleTime: 60_000,
    retry: operationsRetry,
    retryDelay: operationsRetryDelay,
    enabled,
    placeholderData: keepPreviousData,
  });
}

/** The journey drawer's rows: the cohort behind an Onboarding / Redeployment number on the Flow card. */
export function useOperationsJourneyItemsQuery(params: OperationsParams, filter: OperationsJourneyItemsFilter, enabled: boolean) {
  return useQuery<OperationsJourneyItemsDto>({
    queryKey: ["operations", "journeys", params, filter],
    queryFn: () => getOperationsJourneyItems(params, filter),
    staleTime: 60_000,
    retry: operationsRetry,
    retryDelay: operationsRetryDelay,
    enabled,
    placeholderData: keepPreviousData,
  });
}

/** The intake drawer's rows. Keyed on the full params: the request slicers apply to intake as on the Flow card (2026-10-22). */
export function useOperationsIntakeItemsQuery(params: OperationsParams, filter: OperationsIntakeItemsFilter, enabled: boolean) {
  return useQuery<OperationsIntakeItemsDto>({
    queryKey: ["operations", "intake", "items", params, filter],
    queryFn: () => getOperationsIntakeItems(params, filter),
    staleTime: 60_000,
    enabled,
    placeholderData: keepPreviousData,
  });
}
